import dayjs from "@/plugins/dayjsExtensions";
import axios, { AxiosRequestConfig } from "axios";
import { ConfigType } from "dayjs";

let config: Record<string, any> = {
  baseUrl: process.env.VUE_APP_BASE_URL,
  demo: process.env.VUE_APP_DEMO,
  now: null,
  dateTimeOffset: "+00:00",
  offsetInMinutes: 0
};

export default {
  setup(newConfig: any) {
    config = Object.assign(config, newConfig);
  },
  parseDate(date: ConfigType) {
    if (date) {
      return dayjs(date);
    } else {
      throw "Use Resolver.serverNow() to get the current time";
    }
  },
  serverNow() {
    // use the server set 'now' time
    if (config.now) {
      return dayjs(config.now);
    } else {
      throw "Trying to get now before server time set";
    }
  },
  localNow() {
    return dayjs();
  },
  get dateTimeOffset() {
    return config.dateTimeOffset;
  },
  get offsetInMinutes() {
    return config.offsetInMinutes;
  },
  get demo() {
    return config.demo;
  },
  get adminRequest() {
    return `${config.baseUrl}/AdminRequest.ashx`;
  },
  get system() {
    return `${config.baseUrl}/systemrequest.ashx`;
  },
  get vars() {
    return `${config.baseUrl}/VarRequest.ashx`;
  },
  get accessRequest() {
    return `${config.baseUrl}/AccessRequest.ashx`;
  },
  get census() {
    return `${config.baseUrl}/CensusRequest.ashx`;
  },
  get data() {
    return `${config.baseUrl}/DataRequest.ashx`;
  },
  get redirectRequest() {
    return `${config.baseUrl}/RedirectRequest.ashx`;
  },
  get logRequest() {
    return `${config.baseUrl}/LogRequest.ashx`;
  },
  get towerRequest() {
    return `${config.baseUrl}/TowerRequest.ashx`;
  },
  get verifyRequest() {
    return `${config.baseUrl}/ValidateRequest.ashx`;
  },
  get validateRequest() {
    return `${config.baseUrl}/ValidateRequest.ashx`;
  }
};

const ax = axios.create({
  headers: {
    "X-Requested-With": "XMLHttpRequest",
    "Cache-Control": "no-cache"
  }
});

// excluded keys can be ignored for demo mode and should not be added to the url string
const excludedKeys = [
  "action",
  "tower",
  "format",
  "filters",
  "sortBy",
  "browser"
];

const wrapper = function(axiosConfig: AxiosRequestConfig) {
  // If config is in demo mode, switch to static files, otherwise passthrough
  if (config.demo) {
    if (axiosConfig.params) {
      const convertedParams = Object.keys(axiosConfig.params)
        .filter((key: string) => {
          return !excludedKeys.includes(key);
        })
        .map((key: string) => {
          return `${axiosConfig.params[key]}`;
        })
        .join("/");
      delete axiosConfig.params;
      if (axiosConfig.url) {
        axiosConfig.url =
          axiosConfig.url.replace(".ashx", "") +
          "/" +
          convertedParams +
          ".json";
      }
    } else if (axiosConfig.url) {
      if (axiosConfig.url) {
        axiosConfig.url = axiosConfig.url.replace(".ashx", ".json");
      }
    }
  }
  return ax(axiosConfig);
};
wrapper.get = function(path: string) {
  return wrapper({ url: path, method: "GET" });
};

export const http = wrapper;

export const CancelToken = axios.CancelToken;
export const isCancel = axios.isCancel;
